module.exports = __webpack_public_path__ + "img/row.4786dd24.svg";